import { useOwnerSession } from '@/features/owner/api/ownerSession.ts'
import { useTenant } from '@/tenant/useTenant.ts'

/** Navigation only. Database RLS remains the authority for every owner action. */
export function useStudioRole() {
  const { slug } = useTenant()
  const result = useOwnerSession()
  return {
    ...result,
    isOwner: result.session?.memberships.some((membership) => membership.tenantSlug === slug) ?? false,
  }
}
